'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childrenToArray = function childrenToArray(children) {
  var result = [];
  _react2.default.Children.forEach(children, function (child) {
    result.push(child);
  });
  return result;
};

var listOptions = {
  excessKey: true,
  exclusive: true,
  lastWordConnector: true,
  limit: true,
  locale: true,
  twoWordsConnector: true,
  wordsConnector: true
};

exports.default = _react2.default.createClass({
  displayName: 'FormattedList',

  propTypes: {
    className: _react2.default.PropTypes.string,
    excessKey: _react2.default.PropTypes.string,
    exclusive: _react2.default.PropTypes.bool,
    lastWordConnector: _react2.default.PropTypes.string,
    limit: _react2.default.PropTypes.number,
    locale: _react2.default.PropTypes.string,
    twoWordsConnector: _react2.default.PropTypes.string,
    wordsConnector: _react2.default.PropTypes.string
  },

  getPassThroughProps: function getPassThroughProps() {
    var _this = this;

    var passThrough = {};
    Object.keys(this.props).forEach(function (key) {
      if (!listOptions[key]) {
        passThrough[key] = _this.props[key];
      }
    });
    return passThrough;
  },
  render: function render() {
    return _react2.default.createElement(
      'span',
      this.getPassThroughProps(),
      _I18n2.default.formatListArray(childrenToArray(this.props.children), this.props)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/components/FormattedList.js
// module id = 333
// module chunks = 0